<template>
	<div :class="['basic-info', { 'custom': isYili }]">
		<img class="logo" v-if="getIrBaseInfo.logo" :src="getIrBaseInfo.logo" alt="" @click="goToIntroduce" />
		<div class="company-hot" @click="goToIntroduce">
			<p class="company-name">{{ getIrName }}</p>
			<p v-if="getIrIndustryName" class="company-introl">
				<span class="code">{{ getCodeWithMarket }} </span
				><span style="margin-left: 10px" v-if="isZmny">01898.HK</span><span class="gap">|</span
				>{{ $t('enterprise.industry') }}{{ getIrIndustryName }}
				<template v-if="companyLoaded && !isThirdMiniProgram && moduleIsPublish('company_profile')">
					<span class="iconfont iconjiantouyou"></span>
					<span style="float: right">{{ $t('enterprise.see-more') }}</span>
				</template>
			</p>
			<p class="company-solgan">{{ getIrSlogan }}</p>
		</div>
		<div class="follow-box">
			<span class="action-btn btn-research" v-if="moduleIsPublish('appointment')" @click="jumpToAppoint">{{
				getModuleName('appointment')
			}}</span>
			<span class="action-btn btn-feedback" v-if="moduleIsPublish('leave_word')" @click="jumpToFeedback">
				<img class="feedback-icon" src="@/assets/images/icon_feedback.png" alt="" />
			</span>
			<span
				class="action-btn btn-feedback"
				v-if="moduleIsPublish('message_subscription')"
				@click="jumpToSubscription"
			>
				<img class="feedback-icon" src="@/assets/images/icon_message.png" alt="" />
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { irstore } from '@/fetch/interface';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCommonData } from '@rebuild/hooks/useCommonData';

export default {
	data() {
		return {
			tg_swiperOption: {
				slidesPerView: 'auto',
				spaceBetween: '3.2%'
			},

			companyLoaded: false,
			useConfig: false,
			extraInfo: {},
			pageData: {}
		};
	},
	computed: {
		...mapGetters([
			'getIrTemplateFlattenModules',
			'getIrIndustryName',
			'getIrName',
			'getIrSlogan',
			'getIrBaseInfo'
		]),

		getCodeWithMarket() {
			const { code, market } = this.getIrBaseInfo;
			if (code && market) {
				return `${code}.${market.toUpperCase()}`;
			}
			return '';
		}
	},
	mounted() {
		this.loadCompanyInfo();
	},
	methods: {
		getModuleName(moduleId) {
			const allModules = this.getIrTemplateFlattenModules;
			const module = allModules.find(m => m.moduleId === moduleId);
			return module?.name || '';
		},
		moduleIsPublish(moduleId) {
			const arr = this.getIrTemplateFlattenModules;
			return arr.some(item => item.moduleId === moduleId);
		},

		loadCompanyInfo() {
			this.$axios
				.get(irstore.getCompanyInfo(this.getIrBaseInfo.id))
				.then(res => {
					const data = res?.data || [];
					if (data && data.length) {
						let c_config, c_own, c_summary;
						data.forEach(item => {
							// 自有页面
							if (item.module.id == 'company_own_page') c_own = item;
							// 配置页面
							if (item.module.id == 'company_config_page') c_config = item;
							// 企业简介
							if (item.module.id == 'company_summary') c_summary = item;
						});
						if (c_config) this.useConfig = true;
						if (c_own) this.extraInfo = c_own?.data || {};
						if (c_summary) this.pageData = c_summary;

						this.companyLoaded = true;
					}
				})
				.catch(() => {});
		},
		goToIntroduce() {
			if (!this.companyLoaded) return;
			if (this.useConfig) {
				this.viewCompany({
					option: this.pageData,
					isOwn: false
				});
			} else {
				this.viewCompany({
					option: {
						data: this.extraInfo
					},
					isOwn: true
				});
			}
		}
	},
	setup() {
		const { goToModule } = useNavigation();
		const jumpToAppoint = () => {
			goToModule('appointment');
		};
		const jumpToFeedback = () => {
			goToModule('leave_word');
		};
		const jumpToSubscription = () => {
			goToModule('message_subscription');
		};

		const { viewModule } = useModuleNavigation();
		const viewCompany = params => {
			viewModule('company_profile', params);
		};

		const { isThirdMiniProgram, isYili, isZmny } = useCommonData();

		return {
			jumpToAppoint,
			jumpToFeedback,
			jumpToSubscription,
			viewCompany,
			isThirdMiniProgram,
			isYili,
			isZmny
		};
	}
};
</script>

<style lang="less" scoped>
.basic-info {
	.logo {
		position: absolute;
		top: -0.34rem;
		left: 0.12rem;
		width: 0.8rem;
		height: 0.8rem;
		border: 2px solid #e4e4e4;
		border-radius: 0.8rem;
		background: #e4e4e4;
	}
	.company-hot {
		margin: 0 -0.12rem;
		padding: 0 0.12rem 0.22rem;
	}
	.company-name {
		font-style: normal;
		font-weight: 500;
		font-size: 0.19rem;
		line-height: 0.265rem;
		color: #333;
	}
	.company-introl {
		padding-top: 0.06rem;
		font-style: normal;
		font-weight: 400;
		font-size: 0.12rem;
		line-height: 0.17rem;
		color: #666;
		.gap {
			padding: 0 0.1rem;
		}
		.iconjiantouyou {
			float: right;
			font-size: 0.12rem;
		}
	}
	.company-solgan {
		padding-top: 0.12rem;
		font-size: 0.13rem;
		line-height: 0.18rem;
		color: #333;
	}
	.follow-box {
		display: flex;
		position: absolute;
		top: 0.27rem;
		right: 0.12rem;
		.action-btn {
			height: 0.3rem;
			background: #f5f5f5;
			border-radius: 4px;
		}
		.btn-research {
			max-width: 1rem;
			padding: 0 0.17rem;
			font-size: 0.13rem;
			line-height: 0.3rem;
			color: #f76a2b;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.btn-feedback {
			margin-left: 0.07rem;
			width: 0.3rem;
			height: 0.3rem;
			display: flex;
			justify-content: center;
			align-items: center;

			.feedback-icon {
				width: 0.2rem;
				height: 0.2rem;
			}
		}
		.followLoading {
			display: inline-block;
			width: 0.14rem;
			animation: load 2s linear infinite;
		}
		.follow-active {
			color: rgba(247, 106, 43, 0.6);
		}
	}
	.active-title {
		position: relative;
		padding: 0.2rem 0 0.1rem 0;
		font-weight: 500;
		font-size: 0.15rem;
		line-height: 0.21rem;
		color: #333;
		.position-abs {
			right: 0;
			top: 0.21rem;
		}
	}
	.default-style {
		position: relative;
		padding: 0.12rem;
		width: 2.53rem;
		height: 1.69rem;
		border-radius: 0.08rem;
		h4 {
			font-weight: 500;
			font-size: 0.15rem;
			line-height: 0.21rem;
			color: #333;
		}
	}
	.single-box {
		width: 100%;
		height: 0.66rem;
		padding: 0.12rem 0.18rem;
		border-radius: 0.04rem;
		h5 {
			font-size: 0.11rem;
			line-height: 0.15rem;
			color: #666;
		}
		p {
			padding-top: 0.05rem;
			font-size: 0.15rem;
			line-height: 0.21rem;
			color: #333;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		&.roadshow-box {
			background: url(~@/assets/images/touguanluyan-bg2.svg) no-repeat center top;
			background-size: 100%;
			border: none;
		}
		&.conference-box {
			border: none;
			background: url(~@/assets/images/touguanxianxia-bg2.svg) no-repeat;
			background-size: 100%;
		}
		&.reseach-box {
			border: none;
			background: url(~@/assets/images/touguandiaoyan-bg2.svg) no-repeat;
			background-size: 100%;
		}
	}
	.roadshow-box {
		border: 1px solid rgba(255, 239, 215, 0.8);
		background: url(~@/assets/images/touguanluyan-bg.svg) no-repeat center top;
		background-size: 100%;
	}
	.conference-box {
		border: 1px solid #edefff;
		background: url(~@/assets/images/touguanxianxia-bg.svg) no-repeat;
		background-size: 100%;
	}
	.reseach-box {
		border: 1px solid rgba(255, 239, 215, 0.8);
		background: url(~@/assets/images/touguandiaoyan-bg.svg) no-repeat;
		background-size: 100%;
	}
	.position-abs {
		position: absolute;
		top: 0.15rem;
		right: 0.12rem;
	}
	.active-box {
		height: 1.16rem;
		margin-top: 0.08rem;
		padding: 0.14rem 0.1rem;
		background: rgba(255, 255, 255, 0.72);
		backdrop-filter: blur(2px);
		border-radius: 8px;
		li {
			display: flex;
			.list-icon {
				margin-right: 0.06rem;
				width: 0.16rem;
			}
			.list-content-box {
				margin-bottom: 0.14rem;
				font-size: 0.15rem;
				line-height: 0.21rem;
				color: #333;
				word-break: break-all;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				vertical-align: middle;
				.v-rl-item__status {
					color: #5082f0;
					background: rgba(80, 130, 240, 0.1);
					border-radius: 2px;
					margin-right: 0.04rem;
					padding: 0 0.05rem;
					font-size: 0.1rem;
					text-align: center;
					line-height: 0.16rem;
					// vertical-align: middle;
					display: inline-flex;
					align-items: center;
					&.playback {
						color: #5d667a;
						background: rgba(93, 102, 122, 0.1);
					}
					&.playing {
						padding-left: 0.14rem;
						color: #fc4d39;
						background: rgba(252, 77, 57, 0.1) url('~@/assets/images/irstore_playing.gif') 0.01rem center
							no-repeat;
						background-size: 0.12rem;
						vertical-align: 0.5em;
					}
					.icon-svg {
						margin-right: 0.03rem;
					}
				}
			}
		}
	}
	.more {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: 0.11rem;
		line-height: 0.15rem;
		color: #666;
		.iconjiantouyou {
			font-size: 0.12rem;
		}
	}

	// 伊利自定义样式
	&.custom {
		margin-top: 0;
		.logo {
			top: 0.2rem;
			height: 0.5rem;
			width: 0.5rem;
		}
		.company-name {
			font-weight: 500;
			font-size: 0.19rem;
			line-height: 0.23rem;
			color: #1d2129;
			position: absolute;
			top: 0.33rem;
			left: 0.72rem;
		}
		.company-introl {
			padding-top: 0.22rem;
			font-size: 0.12rem;
			line-height: 0.16rem;
			color: #a5a5a5;
			.code {
				color: #a5a5a5;
				font-size: 0.12rem;
				line-height: 0.16rem;
			}
		}
		.company-solgan {
			padding-top: 0.1rem;
		}
	}
}
</style>
